/**
 * Clipboard hook for copying text to clipboard
 * Follows LiveView best practices - browser API wrapper only
 */
const Clipboard = {
  mounted () {
    // Handle copy to clipboard - pure browser API wrapper
    this.handleEvent('copy_to_clipboard', ({ text }) => {
      navigator.clipboard.writeText(text).then(() => {
        this.pushEvent('flash', { type: 'info', message: 'Copied to clipboard' })
      }).catch(() => {
        this.pushEvent('flash', { type: 'error', message: 'Failed to copy' })
      })
    })
  }
}

export default Clipboard
